import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import firebaseInit from '@/firebaseInit.js'
import event from './modules/event'
import entryGroup from './modules/entryGroup'
import admin from './modules/admin'
import showSeries_ from './modules/showSeries'
// Removed Log Rocket because it was basically useless and slowing the site down I thought.

import LogRocket from 'logrocket'
import createPlugin from 'logrocket-vuex'
const logrocketPlugin = createPlugin(LogRocket)

/* if (process.env.NODE_ENV !== 'development') {
  LogRocket.init('kzaivo/showman')
} */

var auth = firebaseInit.auth

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [logrocketPlugin],
  modules: {
    event,
    entryGroup,
    admin,
    showSeries_
  },
  state: {
    // Authentication Set up

    loading: false,
    appInitiated: false,
    authInitiated: false,
    apiInstance: axios.create({
      // baseURL: 'http://localhost:5000',
      baseURL: process.env.VUE_APP_ROOT_API, // 'https://showman-db.herokuapp.com/',
      timeout: 40000
    }),
    railsAPI: axios.create({
      baseURL: 'https://showman-api-0e24b17f8ff6.herokuapp.com/' // admin/dashboard/financials 
    }),
    authorizationSet: false,
    user: JSON.parse(localStorage.getItem('currentUser')), // auth.currentUser,
    userData: JSON.parse(localStorage.getItem('userData')),

    // General Application
    upcomingEvents: [],
    recentEvents: [],
    allEvents: [],
    showSeries: [],
    judges: [],
    classes: {},
    eventEvents: [],
    showTypes: [],
    stripeSession: {},
    searchParams: {
      location: null,
      radius: 50,
      distanceType: 'radius', // 'radius' or 'drivingTime'
      drivingTime: 30,
      date: null,
      startDate: null,
      endDate: null,
      genre: null,
      artist: null,
      species: [],
      name: null,
      btrjla: null
    },
    mapBounds: null, // Store current map bounds for dynamic filtering
    showMap: true, // Map visibility state
    archiveSearchParams: {
      state: null,
      species: null,
      name: null,
      year: null
    }
  },
  mutations: {
    authInitiated: state => {
      state.authInitiated = true
    },
    appInitiated: state => {
      state.appInitiated = true
    },
    // User Mutations
    setUser: (state, payload) => {
      if (payload.user) {
        if (payload.user.address) {
          if (!payload.user.address.country) {
            payload.user.address.country = 'US'
          }
        }
      }
      state.user = payload.user
      localStorage.setItem('currentUser', JSON.stringify(state.user))
      if (state.user) {
        if (state.user.user_id) {
          /* if (process.env.NODE_ENV !== 'development') {
            Vue.$honeybadger.setContext({
              user_id: state.user.user_id,
              user_email: state.user.email
            })
          } */
          /* LogRocket.identify(state.user.user_id, {
            email: state.user.email,
            name: `${state.user.first_name} ${state.user.last_name}`
          }) */
        }
      } else {
        /* if (process.env.NODE_ENV !== 'development') {
          Vue.$honeybadger.resetContext()
        } */
      }
    },
    setStripeSession: (state, payload) => {
      state.stripeSession = payload
    },
    setUserField: (state, payload) => {
      state.user[payload.field] = payload.value
    },
    setAuthHeaders: (state, payload) => {
      if (state.apiInstance) {
        state.apiInstance.defaults.headers.Authorization = payload.token
      }

      if (state.railsAPI) {
        state.railsAPI.defaults.headers['Firebase-Token'] = payload.token
      }
    },
    setEventHeader: (state, payload) => {
      console.log('in')
      if (state.railsAPI) {
        console.log('set')
        state.railsAPI.defaults.headers['Showman-Event-Id'] = payload.event_id
      }
      console.log(state.railsAPI.defaults.headers)
    },
    authorizationSet: (state) => {
      state.authorizationSet = true
    },
    setUserData: (state, payload) => {
      state.userData = payload.userData
      localStorage.setItem('userData', JSON.stringify(state.userData))
    },
    setUpcomingEvents: (state, payload) => {
      state.upcomingEvents = payload.events
    },
    setRecentEvents: (state, payload) => {
      state.recentEvents = payload.events
    },
    setAllEvents: (state, payload) => {
      state.allEvents = payload.events
    },
    setShowSeries: (state, payload) => {
      state.showSeries = payload.events
    },
    /* setJudges: (state, payload) => {
      state.judges = payload.judges
    }, */
    addJudgeToList: (state, payload) => {
      state.judges.push(payload)
    },
    updateJudgeList: (state, payload) => {
      state.judges.forEach(j => {
        if (j.judge_id === payload.judge_id) {
          j = payload
        }
      })
    },
    setEventEvents: (state, payload) => {
      state.eventEvents = payload.events
    },
    setShowTypes: (state, payload) => {
      state.showTypes = payload.showTypes
    },
    addUserAnimalList: (state, animal) => {
      animal.status = 'ACTIVE'
      state.userData.animals.push(animal)
    },
    updateUserAnimalList: (state, animal) => {
      state.userData.animals.forEach(a => {
        if (a.animal_id === animal.animal_id) {
          Vue.set(a, 'animal_details', animal.animal_details)
        }
      })
    },
    // Commented Out on 4/28
    addToExhibitorList: (state, exhibitor) => {
      state.userData.exhibitors.push(exhibitor)
    },
    updateExhibitorInList: (state, exhibitor) => {
      state.userData.exhibitors.forEach(e => {
        if (e.exhibitor_id === exhibitor.exhibitor_id) {
          Vue.set(e, 'entry_details', exhibitor.exhibitor_details)
        }
      })
    },
    // Generic User Mutators
    userDataAddData: (state, payload) => {
      state.userData[payload.name].push(payload)
    },
    userDataRemoveNewData: (state, payload) => {
      // Remove last item if it didn't save
      state.userData[payload.name].pop()
    },
    userDataSetNewDataID: (state, payload) => {
      state.userData[payload.name][state.userData[payload.name].length - 1][payload.idName] = payload.id
    },
    userDataUpdateData: (state, payload) => {
      state.userData[payload.name].forEach(d => {
        if (d[payload.idName] === payload[payload.idName]) {
          d = payload
        }
      })
    },
    userDataRemoveData: (state, payload) => {
      state.userData[payload.name] = state.userData[payload.name].filter(d => {
        if (d[payload.idName] !== payload[payload.idName]) {
          return d
        }
      })
    },
    userDataAddData_addon: (state, payload) => {
      state.userData.show_series_membership.forEach(m => {
        if (m.show_series_id === payload.show_series_id && m.exhibitor_id === payload.exhibitor_id) {
          m.add_ons.push(payload)
        }
      })
    },
    userData_removeAddon: (state, payload) => {
      state.userData.show_series_membership.forEach(m => {
        if (m.show_series_id === payload.show_series_id && m.exhibitor_id === payload.exhibitor_id) {
          m.add_ons = m.add_ons.filter(a => {
            return payload.show_series_member_add_on_id !== a.show_series_member_add_on_id
          })
        }
      })
    },
    userDataAddData_animalNomination: (state, payload) => {
      state.userData.show_series_membership.forEach(m => {
        if (m.show_series_id === payload.show_series_id && m.exhibitor_id === payload.exhibitor_id) {
          m.animal_nominations.push(payload)
        }
      })
    },
    userDataUpdateData_animalNomination: (state, payload) => {
      state.userData.show_series_membership.forEach(m => {
        if (m.show_series_id === payload.show_series_id && m.exhibitor_id === payload.exhibitor_id) {
          m.animal_nominations.forEach(an => {
            if (an.show_series_animal_nomination_id === payload.show_series_animal_nomination_id) {
              an.nomination.details = payload.nomination.details
            }
          })
        }
      })
    },
    userData_removeAnimalNomination: (state, payload) => {
      state.userData.show_series_membership.forEach(m => {
        if (m.show_series_id === payload.show_series_id && m.exhibitor_id === payload.exhibitor_id) {
          m.animal_nominations = m.animal_nominations.filter(a => {
            return payload.show_series_animal_nomination_id !== a.show_series_animal_nomination_id
          })
        }
      })
    },
    userData_removeMember: (state, payload) => {
      state.userData.show_series_membership = state.userData.show_series_membership.filter(m => {
        return m.id !== payload.id
      })
    },
    userData_removeSanctioningForm: (state, payload) => {
      state.userData.series_sanctioning = state.userData.series_sanctioning.filter(s => {
        return s.id !== payload.id
      })
    },
    userData_updateSanctioningForm: (state, payload) => {
      state.userData.series_sanctioning.forEach((s, i) => {
        if (s.id === payload.id) {
          Vue.set(state.userData.series_sanctioning, i, payload)
        }
      })
    },
    setSearchParam: (state, payload) => {
      state.searchParams[payload.field] = payload.value
    },
    setArchiveSearchParam: (state, payload) => {
      state.archiveSearchParams[payload.field] = payload.value
    },
    setMapBounds: (state, payload) => {
      state.mapBounds = payload
    },
    removeShowTemplate: (state, payload) => {
      state.showSeries = state.showSeries.filter(s => {
        return s.show_template_id !== payload.show_template_id
      })
    },
    setDistanceType: (state, distanceType) => {
      state.searchParams.distanceType = distanceType
    },
    setDrivingTime: (state, drivingTime) => {
      state.searchParams.drivingTime = drivingTime
    },
    setSpecies: (state, species) => {
      state.searchParams.species = species
    },
    setLocation: (state, location) => {
      state.searchParams.location = location
    },
    setRadius: (state, radius) => {
      state.searchParams.radius = radius
    },
    setStartDate: (state, startDate) => {
      state.searchParams.startDate = startDate
    },
    setEndDate: (state, endDate) => {
      state.searchParams.endDate = endDate
    },
    setName: (state, name) => {
      state.searchParams.name = name
    },
    logUserIn: (state, payload) => {
      state.user = payload
      state.auth_loaded = true
    },
    logUserOut: (state) => {
      state.user = null
      state.userData = null
    },
    setShowMap: (state, payload) => {
      state.showMap = payload
    }
  },
  actions: {
    // User Actions
    authChange: ({commit, dispatch}, payload) => {
      // logUserOutcommit('setUser', payload)
      if (payload.user) {
        payload.user.getIdToken(true)
          .then(token => {
            commit('setAuthHeaders', {token: token})
            commit('authInitiated')
            commit('authorizationSet')
            dispatch('loadUserData', {uid: payload.user.uid})
          })
      } else {
        commit('setUser', {user: null})
        commit('setUserData', {userData: null})
        commit('setAuthHeaders', {token: ''})
        commit('authInitiated')
      }
    },
    createUser: ({state}, payload) => {
      var user = null
      return auth.createUserWithEmailAndPassword(payload.email, payload.password)
        .then((userDoc) => {
          user = userDoc.user
          payload.userData.user_id = user.uid
          payload.userData.created_by = user.uid
          return payload.userData
        })
        .then(result => {
          return state.apiInstance.post('/data/users', result)
        })
        // TODO: Implement this in a betterway
        /* .then(() => {
          let exhibitor = {
            user_id: payload.userData.user_id,
            first_name: payload.userData.first_name,
            last_name: payload.userData.last_name
          }
          return state.apiInstance.post('/data/exhibitors/', exhibitor)
        }) */
        .then(() => {
          let exhibitor = {
            user_id: payload.userData.user_id,
            first_name: payload.userData.first_name,
            last_name: payload.userData.last_name
          }
          return state.apiInstance.post('/data/exhibitors/', exhibitor)
        })
        .then(() => {
          return user.updateProfile({
            displayName: payload.userData.first_name,
            phoneNumber: payload.userData.phone_number
          })
        })
        .then(() => {
          user.sendEmailVerification()
        })
    },
    updateUser: ({state, commit}, payload) => {
      commit('setUser', {user: payload})
      return state.apiInstance.put(`/data/users/${payload.user_id}`, payload)
    },
    updateEmail: ({state, commit, dispatch}, payload) => {
      const credential = firebaseInit.EmailAuthProvider.credential(payload.original_email, payload.password)
      let currentUser = auth.currentUser

      return currentUser.reauthenticateWithCredential(credential).then(() => {
        return currentUser.updateEmail(payload.email)
          .then(() => {
            return state.apiInstance.put(`/data/users/${payload.user_id}`, payload)
              .then(response => {
                dispatch('loadUserData', {uid: payload.user_id})
                state.apiInstance.post('/updateUserEmailExternal', {user_id: payload.user_id, email: payload.email})
                if (payload.stripe_customer_id) {
                  state.apiInstance.post('/stripe/updateEmail', payload)
                }
              })
          })
          .catch((error) => {
            // console.log(error)
            throw error
          })
      }).catch((error) => {
        throw error
      })
    },
    updatePassword: ({state}, payload) => {
      const credential = firebaseInit.EmailAuthProvider.credential(payload.email, payload.password)
      let currentUser = auth.currentUser

      return currentUser.reauthenticateWithCredential(credential).then(() => {
        return currentUser.updatePassword(payload.new_password)
          .catch((error) => {
            // console.log(error)
            throw error
          })
      }).catch((error) => {
        throw error
      })
    },
    refreshToken: ({commit}, payload) => {
      if (payload.user) {
        payload.user.getIdToken(true)
          .then(token => {
            commit('setAuthHeaders', {token: token})
          })
      }
    },
    logUserOut: ({commit}) => {
      commit('setUser', {user: null})
      commit('setUserData', {userData: null})
      return auth.signOut()
    },
    logUserIn: ({state}, payload) => {
      return auth.signInWithEmailAndPassword(payload.email, payload.password)
    },
    forgotPassword: ({state}, payload) => {
      return auth.sendPasswordResetEmail(payload.email)
    },
    loadUserData: ({commit, state}, payload) => {
      return state.apiInstance.get(`/callFunction/userData?userID=${payload.uid}`)
        .then(response => {
          if (response.data.data) {
            commit('setUser', {user: response.data.data.user})
            commit('setUserData', {userData: response.data.data})
            return 'good'
          } else {
            // Return promise error
            commit('setUser', {user: null})
            commit('setUserData', {userData: null})
            return 'error'
          }
        })
    },

    // Exhibitor Actions
    updateExhibitorAnimalStatus: ({commit, state}, payload) => {
      // Update Animal Details
      state.apiInstance.put(`/data/animals/${payload.animal.animal_id}`, {status: payload.animal.status})
        .then(() => {
          commit('updateUserAnimalList', payload.animal)
        })
    },
    updateAnimalDetails: ({commit, state}, payload) => {
      // Update Animal Details
      return state.apiInstance.put(`/data/animals/${payload.animal.animal_id}`, {animal_details: payload.animal.animal_details})
        .then(() => {
          commit('updateUserAnimalList', payload.animal)
        })
    },
    createNewAnimal: ({commit, state}, payload) => {
      return state.apiInstance.post(`/data/animals/`, payload.animal)
        .then((response) => {
          payload.animal.animal_id = response.data.data.animal_id
          commit('addUserAnimalList', payload.animal)
        })
    },
    // General Application
    loadAppData: ({commit, state}) => {
      state.apiInstance.get('/callFunction/showman')
        .then(response => {
          if (response.data.data) {
            commit('setUpcomingEvents', {events: response.data.data.upcoming})
            commit('setShowSeries', {events: response.data.data.show_series})
            commit('setRecentEvents', {events: response.data.data.recent_events})
            commit('setAllEvents', {events: response.data.data.events})
            // commit('setJudges', {judges: response.data.data.judges})
            commit('appInitiated')
            commit('setEventEvents', {events: response.data.data.eventEvents})
            commit('setShowTypes', {showTypes: response.data.data.show_types})
          }
        })
    },

    // Generic User Actions
    addUserData: ({commit, state}, payload) => {
      payload.idName = payload.name.slice(0, -1) + '_id'

      payload.created_by = state.user.user_id
      // payload.user_id = state.user.user_id
      commit('userDataAddData', payload)
      return state.apiInstance.post(`/data/${payload.name}/`, payload)
        .then(response => {
          if (response.status < 400) {
            payload.id = response.data.data[payload.idName]
            commit('userDataSetNewDataID', payload)
            return response
          } else {
            // console.log('UserDatRemoveNew')
            commit('userDataRemoveNewData', payload)
            return Promise.reject(new Error('Data not added'))
          }
        })
        .catch(error => {
          commit('userDataRemoveNewData', payload)
          return Promise.reject(error)
        })
    },
    updateUserData: ({commit, state}, payload) => {
      payload.idName = payload.name.slice(0, -1) + '_id'
      return state.apiInstance.put(`/data/${payload.name}/${payload[payload.idName]}`, payload)
        .then(response => {
          if (response.status === 200) {
            commit('userDataUpdateData', payload)
          } else {
            return Promise.reject(new Error('Update Failed'))
          }
        })
    },
    deleteUserData: ({commit, state}, payload) => {
      payload.idName = payload.name.slice(0, -1) + '_id'

      return state.apiInstance.delete(`/data/${payload.name}/${[payload[payload.idName]]}`)
        .then(response => {
          if (response.status === 200) {
            commit('userDataRemoveData', payload)
          } else {
            return Promise.reject(new Error('Data not deleted'))
          }
        })
    },

    // Stripe Session
    createStripeSession: ({commit, state}, payload) => {
      return state.apiInstance.post('/stripe/createCheckoutSession', payload)
        .then(response => {
          // window.location.href = response.data.data.url
          commit('setStripeSession', response.data.data)
          return response.data.data
        })
    },
    createStripeSession_redirect: ({commit, state}, payload) => {
      state.apiInstance.post('/stripe/createCheckoutSession', payload)
        .then(response => {
          commit('setStripeSession', response.data.data)
          window.location.href = response.data.data.url
        })
    },
    // Judges
    addJudge: ({commit, state}, payload) => {
      return state.apiInstance.post('/data/judges', payload)
        .then(response => {
          if (response.status === 200) {
            payload.judge_id = response.data.data.judge_id
            commit('addJudgeToList', payload)
            return payload
          } else {
            return Promise.reject(new Error('Judge not added.'))
          }
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    updateJudge: ({commit, state}, payload) => {
      return state.apiInstance.put(`/data/judges/${payload.judge_id}`, payload)
        .then(response => {
          if (response.status === 200) {
            commit('updateJudgeList', payload)
          } else {
            return Promise.reject(new Error('Judge not updated.'))
          }
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    // Show Templates
    addShowTemplate: ({commit, state}, payload) => {
      return state.apiInstance.post('/data/showTemplates', payload)
        .then(response => {
          if (response.status === 200) {
            payload.show_template_id = response.data.data.show_template_id
            // commit('addJudgeToList', payload)
            return payload
          } else {
            return Promise.reject(new Error('Template not added.'))
          }
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    updateShowTemplate: ({commit, state}, payload) => {
      return state.apiInstance.put(`/data/showTemplates/${payload.show_template_id}`, payload)
        .then(response => {
          if (response.status === 200) {
            // commit('updateJudgeList', payload)
          } else {
            return Promise.reject(new Error('Template not updated.'))
          }
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    deleteShowTemplate: ({commit, state}, payload) => {
      return state.apiInstance.delete(`/data/showTemplates/${payload.show_template_id}`)
        .then(response => {
          if (response.status === 200) {
            commit('removeShowTemplate', payload)
            return payload
          } else {
            return Promise.reject(new Error('Template not deleted.'))
          }
        })
    },
    setSearchParam: ({commit}, payload) => {
      switch (payload.field) {
        case 'species':
          commit('setSpecies', payload.value)
          break
        case 'location':
          commit('setLocation', payload.value)
          break
        case 'radius':
          commit('setRadius', payload.value)
          break
        case 'drivingTime':
          commit('setDrivingTime', payload.value)
          break
        case 'distanceType':
          commit('setDistanceType', payload.value)
          break
        case 'startDate':
          commit('setStartDate', payload.value)
          break
        case 'endDate':
          commit('setEndDate', payload.value)
          break
        case 'name':
          commit('setName', payload.value)
          break
      }
    },
    setShowMap: ({commit}, payload) => {
      commit('setShowMap', payload)
    },
    setMapBounds: ({commit}, payload) => {
      commit('setMapBounds', payload)
    }
  },
  getters: {
    judgeSelectList: state => {
      return state.judges.map(judge => {
        return {
          id: judge.judge_id,
          name: `${judge.last_name}, ${judge.first_name}`
        }
      })
    },
    getUserID: state => {
      if (!state.user) {
        return null
      } else if (state.user.uid) {
        return state.user.uid
      } else {
        return state.user.user_id
      }
    },
    apiInstanceAuthHeader: state => {
      return state.apiInstance.defaults.headers.Authorization
    },
    filteredUpcomingShows: (state, getters) => {
      let list = state.upcomingEvents
      
      // Filter by state when map is hidden and location type is 'state'
      if (!state.showMap && state.searchParams.location && state.searchParams.location.type === 'state') {
        // For state filtering, match by state abbreviation or full name
        const stateName = state.searchParams.location.name
        const stateAbbr = state.searchParams.location.state_info?.abbreviation
        
        list = list.filter(s => {
          if (s.location_details && s.location_details.state) {
            const showState = s.location_details.state
            // Match by full state name or abbreviation
            return showState === stateName || 
                   showState === stateAbbr ||
                   showState.toLowerCase() === stateName.toLowerCase()
          }
          return false
        })
      }
      // Filter by location and radius (apply when location and radius are set, but not for state filtering)
      else if (state.searchParams.location && state.searchParams.radius && state.searchParams.location.type !== 'state') {
        list = list.filter(s => {
          const showLocation = getters.getShowCoordinates(s)
          if (showLocation) {
            let centerLat, centerLng
            if (state.searchParams.location.coordinates) {
              centerLat = state.searchParams.location.coordinates.lat
              centerLng = state.searchParams.location.coordinates.lng
            } else {
              centerLat = state.searchParams.location.lat
              centerLng = state.searchParams.location.lng
            }
            
            const distance = getters.calculateDistance(
              centerLat,
              centerLng,
              showLocation.lat,
              showLocation.lng
            )
            return distance <= state.searchParams.radius
          }
          return false
        })
      }
      
      // Filter by date range
      if (state.searchParams.startDate || state.searchParams.endDate) {
        list = list.filter(s => {
          if (!s.start_date) return false
          
          const showDate = new Date(s.start_date)
          const startDate = state.searchParams.startDate ? new Date(state.searchParams.startDate) : null
          const endDate = state.searchParams.endDate ? new Date(state.searchParams.endDate) : null
          
          // Check if show date is within the specified range
          if (startDate && showDate < startDate) return false
          if (endDate && showDate > endDate) return false
          
          return true
        })
      }
      
      // Filter by species
      if (state.searchParams.species && Array.isArray(state.searchParams.species) && state.searchParams.species.length > 0) {
        list = list.filter(s => {
          if (s.species) {
            // Check if the event has ANY of the selected species
            return state.searchParams.species.some(selectedSpecies => 
              s.species.some(eventSpecies => eventSpecies.species === selectedSpecies)
            )
          } else {
            return false
          }
        })
      }
      
      return list
    },
    filteredRecentShows: (state, getters) => {
      let list = state.recentEvents
      
      // Filter by species
      if (state.searchParams.species && Array.isArray(state.searchParams.species) && state.searchParams.species.length > 0) {
        list = list.filter(s => {
          if (s.species) {
            // Check if the event has ANY of the selected species
            return state.searchParams.species.some(selectedSpecies => 
              s.species.some(eventSpecies => eventSpecies.species === selectedSpecies)
            )
          } else {
            return false
          }
        })
      }
      
      return list
    },
    filteredShowsByMapBounds: (state, getters) => {
      // Start with already filtered shows (includes location/radius filtering)
      let filtered = getters.filteredUpcomingShows
      
      // Only apply map bounds filtering if bounds are set
      if (!state.mapBounds) {
        return filtered // Return all filtered shows if no bounds set
      }
      
      const boundsFiltered = filtered.filter(show => {
        const showLocation = getters.getShowCoordinates(show)
        if (!showLocation) return false

        
        // Check if show location is within map bounds
        const withinBounds = showLocation.lat >= state.mapBounds.south &&
               showLocation.lat <= state.mapBounds.north &&
               showLocation.lng >= state.mapBounds.west &&
               showLocation.lng <= state.mapBounds.east
               
        return withinBounds
      })
      
      return boundsFiltered
    },
    searchResults: (state, getters) => {
      if (!state.searchParams.name || state.searchParams.name === '') {
        return []
      }
      
      // State abbreviation to full name mapping
      const stateMapping = {
        'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California',
        'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'FL': 'Florida', 'GA': 'Georgia',
        'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa',
        'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
        'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri',
        'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey',
        'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio',
        'OK': 'Oklahoma', 'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
        'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont',
        'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming'
      }
      
      // Create reverse mapping (full name to abbreviation)
      const reverseStateMapping = {}
      Object.keys(stateMapping).forEach(abbr => {
        reverseStateMapping[stateMapping[abbr].toLowerCase()] = abbr
      })
      
      let allEvents = getters.filteredRecentShows.concat(getters.filteredUpcomingShows)
      let value = state.searchParams.name.trim().replace(/\\+/g, '')
      const regex = new RegExp(value, 'gi')
      
      return allEvents.filter(e => {
        // Search by name
        const nameMatch = e.name.match(regex)
        
        // Search by city
        const cityMatch = e.location_details && e.location_details.city && e.location_details.city.match(regex)
        
        // Enhanced state search - check both abbreviation and full name
        let stateMatch = false
        if (e.location_details && e.location_details.state) {
          const showState = e.location_details.state
          
          // Direct match with the stored state value (could be abbreviation or full name)
          stateMatch = showState.match(regex)
          
          // If no direct match, check if search term is a state name and show state is abbreviation
          if (!stateMatch) {
            const searchTermLower = value.toLowerCase()
            const stateAbbr = reverseStateMapping[searchTermLower]
            if (stateAbbr && showState === stateAbbr) {
              stateMatch = true
            }
          }
          
          // If no match yet, check if search term is abbreviation and show state is full name
          if (!stateMatch) {
            const searchTermUpper = value.toUpperCase()
            const fullStateName = stateMapping[searchTermUpper]
            if (fullStateName && showState.toLowerCase() === fullStateName.toLowerCase()) {
              stateMatch = true
            }
          }
        }
        
        return nameMatch || cityMatch || stateMatch
      })
    },
    // Helper function to get show coordinates
    getShowCoordinates: () => (show) => {
      // Use actual geolocation data from the event
      if (show.location_details && show.location_details.geolocation) {
        return {
          lat: show.location_details.geolocation.latitude,
          lng: show.location_details.geolocation.longitude
        }
      }
      
      return null
    },
    // Helper function to calculate distance between two points using Haversine formula
    calculateDistance: () => (lat1, lng1, lat2, lng2) => {
      const R = 3959 // Radius of the Earth in miles
      const dLat = (lat2 - lat1) * Math.PI / 180
      const dLng = (lng2 - lng1) * Math.PI / 180
      const a = 
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c // Distance in miles
    }
  }
})
